/**
 * AI 문서 아카이브 — 인사정보 (등본·가족관계증명서·근로계약서·자격증/졸업증명서)
 * 4개 카드 중 개인정보 민감도가 가장 높다 — 주민등록번호는 목록에서 마스킹해서 보여준다.
 * 컬럼 암호화·접근로그·선택적 추가인증은 BE 연결 시 적용(로컬 스텁 단계에서는 표시만 한다).
 * [[20260916-세무관리-개요및기업등록]] §3.6 / [[20260923-AI문서아카이브...]] §4.4
 */
import React from 'react';
import { PageContainer } from 'styles/common.styles';
import DocCaptureArchivePanel from 'archive/DocCaptureArchivePanel';

const ArchiveHr = () => (
  <PageContainer>
    <DocCaptureArchivePanel
      category="HR"
      panelTitle="인식 결과 확인·입력"
      sensitive
      sensitiveNotice="주민등록번호 등 민감정보가 포함됩니다. 목록에서는 마스킹 표시되며, 실제 서비스 시 컬럼 암호화·접근 로그·선택적 추가인증이 적용됩니다."
      afterSaveHint="아카이브에 저장했습니다. (인사마스터 연동은 BE 매핑 어댑터 구현 후)"
    />
  </PageContainer>
);

export default ArchiveHr;
